module.exports = __webpack_public_path__ + "static/media/arienzo.d06c9f65.jpeg";